export default "__VITE_ASSET__c1c05972__"